import TimesheetCalendar from "./TimesheetCalendar";

const TimesheetForm: React.FC<{
  isDisable: boolean;
}> = ({ isDisable }) => {
  return (
    <div>
      <TimesheetCalendar isDisable={isDisable || false} />
    </div>
  );
};
export default TimesheetForm;
